import client from './client';

export interface Supply {
  id: string;
  name: string;
  description: string;
  notes?: string;
  supplyType: string;
  supplyTypeDisplay: string;
  supplyClass?: string;
  supplyClassDisplay?: string;
  category: string;
  sku: string;
  manufacturerSku?: string;
  manufacturerSku2?: string;
  manufacturerSku3?: string;
  unitOfMeasure: string;
  quantityInStock: number;
  costPerUnit: number;
  stockValue: number;
  reorderLevel: number;
  reorderQuantity: number;
  supplier: string;
  supplierSku: string;
  purchaseUrl?: string | null;
  imageUrl: string | null;
  storageLocationId?: string | null;
  storageNotes?: string | null;
  dimensionHeight?: number | null;
  dimensionWidth?: number | null;
  dimensionDepth?: number | null;
  dimensionUnit?: string | null;
  isBlank?: boolean;
  blankNotes?: string | null;
  materialType?: string | null;
  finish?: string | null;
  coating?: string | null;
  colorSummary?: string | null;
  weight?: number | null;
  weightUnit?: string | null;
  blankShape?: string | null;
  printableAreaWidth?: number | null;
  printableAreaHeight?: number | null;
  engravableAreaWidth?: number | null;
  engravableAreaHeight?: number | null;
  isDoubleSided?: boolean;
  isCurvedSurface?: boolean;
  apparelSize?: string | null;
  filamentMaker?: string | null;
  filamentType?: string | null;
  filamentDiameter?: string | null;
  filamentNetWeight?: string | null;
  hardwareType?: string | null;
  hardwareOuterDiameter?: number | null;
  hardwareInnerDiameter?: number | null;
  hardwareWireThickness?: number | null;
  hardwareOpeningStyle?: string | null;
  isActive: boolean;
  isLowStock: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ProductSupplyRow {
  id: string;
  productId: string;
  supplyId: string;
  supplyName: string;
  supplyType: string;
  supplySku: string;
  unitOfMeasure: string;
  quantityRequired: number;
  costContribution: number;
  supplyCostPerUnit: number;
  supplyStockAvailable: number;
  hasSufficientStock: boolean;
  unitsMakeable: number;
  notes: string;
  displayOrder: number;
}

export interface SupplyUsage {
  productId: string;
  productName: string;
  productSku: string;
  variantId?: string | null;
  variantName?: string | null;
  variantSku?: string | null;
  usageType: 'PRODUCT' | 'VARIANT' | 'FILAMENT';
  quantityRequired: number;
  unitOfMeasure: string;
}

export const suppliesApi = {
  getById: async (id: string): Promise<Supply> => {
    const response = await client.get<Supply>(`/supplies/${id}`);
    return response.data;
  },

  getProductSupplies: async (productId: string): Promise<ProductSupplyRow[]> => {
    const response = await client.get<ProductSupplyRow[]>(`/supplies/product/${productId}`);
    return response.data;
  },

  getUsage: async (id: string): Promise<SupplyUsage[]> => {
    const response = await client.get<SupplyUsage[]>(`/supplies/${id}/usage`);
    return response.data;
  },

  search: async (query: string): Promise<Supply[]> => {
    const response = await client.get<Supply[]>('/supplies/search', { params: { query } });
    return response.data;
  },

  getByStorageLocation: async (storageLocationId: string): Promise<Supply[]> => {
    const response = await client.get<Supply[]>(`/supplies/storage-location/${storageLocationId}`);
    return response.data;
  },

  getSuggestions: async (params: {
    itemTypeId?: string;
    productionMethodIds?: string[];
  }): Promise<Supply[]> => {
    const response = await client.get<Supply[]>('/supplies/suggestions', { params });
    return response.data;
  },
};
